module.exports = __webpack_public_path__ + "static/media/gears.0fc4d0d1.svg";